import React, {useEffect} from "react";
import {TopLive} from "../../component/topLive";
import EventPublicApiClientFactory from "../../models/EventPublicApiClientFactory";
import {useNavigate, useParams} from "react-router-dom";
import localizedTexts from "./texts/ScoreListView.texts";
import {
    GroupScoreList,
    Organization,
    ScoreList,
    ScoreListDefinition,
    ScoreListDisciplineDefinition,
    ScoreListFieldDefinition, SectionScoreList
} from "../../models/ModelsEventPublic";
import WinFireDropDown, {WinFireDropDownElement} from "./WinFireDropDown";
import {Button} from "bootstrap";

const ScoreListView : React.FC = () => {
    const apiClient = EventPublicApiClientFactory.GetApiClient();
    const navigate = useNavigate();

    const {eventId, shootingProgramDefinitionId} = useParams();

    const [scoreListDisciplines, setScoreListDisciplines] = React.useState<ScoreListDisciplineDefinition[]>([]);
    const [selectedDiscipline, setSelectedDiscipline] = React.useState<ScoreListDisciplineDefinition|undefined>();
    const [selectedProgram, setSelectedProgram] = React.useState<ScoreListDefinition|undefined>();
    const [selectedField, setSelectedField] = React.useState<ScoreListFieldDefinition|undefined>();
    const [groupSelected, setGroupSelected] = React.useState<boolean>(false);
    const [sectionSelected, setSectionSelected] = React.useState<boolean>(false);

    const [scoreList, setScoreList] = React.useState<ScoreList|undefined>();
    const [groupScoreList, setGroupScoreList] = React.useState<GroupScoreList|undefined>();
    const [sectionScoreList, setSectionScoreList] = React.useState<SectionScoreList|undefined>();

    const [organizations, setOrganizations] = React.useState<{organizationName:string, organizationNumber:string}[]>([]);
    const [selectedOrganization, setSelectedOrganization] = React.useState<{organizationName:string, organizationNumber:string}|undefined>();

    const [filter, setFilter] = React.useState<string>("");

    const [showPopup, setShowPopup] = React.useState(false);
    const [popupSelectedOrganization, setPopupSelectedOrganization] = React.useState<Organization|undefined>();

    useEffect(() => {
        loadDisciplineDefinitions();
    }, []);

    useEffect(() => {
        setSelectedProgram(undefined);
        setScoreList(undefined);
        setSelectedField(undefined);
        setSelectedOrganization(undefined);
        setGroupSelected(false);
        setGroupScoreList(undefined);
    }, [selectedDiscipline]);

    useEffect(() => {
        loadScoreList();
    }, [selectedProgram, selectedField, groupSelected, sectionSelected]);

    async function loadDisciplineDefinitions(){
        const result = await apiClient.api.publicEventsLiveScorelistsDetail(`${eventId}`);
        if (result.ok){
            setScoreListDisciplines(result.data);
        }
    }

    async function loadScoreList(){
        setScoreList(undefined);
        setGroupScoreList(undefined);
        setSectionScoreList(undefined);

        if (selectedProgram){
            if (groupSelected){
                const result = await apiClient.api.publicEventsLiveScorelistsGroupDetail(selectedProgram.id??0, selectedField?.id??0, `${eventId}`);
                if (result.ok){
                    setGroupScoreList(result.data);
                    const orgs = new Array<{organizationName:string, organizationNumber:string}>();
                    result.data.scoreListItems?.forEach(sli => {
                        if (sli.organization && orgs.findIndex(o => o.organizationName == sli.organization) == -1){
                            orgs.push({organizationName: sli.organization, organizationNumber: sli.organizationNumber??""});
                        }
                    });
                    setOrganizations(Array.from(orgs));
                }
            } if (sectionSelected){
                const result = await apiClient.api.publicEventsLiveScorelistsSectionDetail(selectedProgram?.id??0, `${eventId}`);
                if (result.ok){
                    setSectionScoreList(result.data);
                    setOrganizations([]);
                }
            } else{
                const result = await apiClient.api.publicEventsLiveScorelistsDetail2(selectedProgram.id??0, selectedField?.id??0, `${eventId}`);
                if (result.ok){
                    setScoreList(result.data);
                    const orgs = new Array<{organizationName:string, organizationNumber:string}>();
                    result.data.scoreListItems?.forEach(sli => {
                        if (sli.organization && orgs.findIndex(o => o.organizationName == sli.organization) == -1){
                            orgs.push({organizationName: sli.organization, organizationNumber: sli.organizationNumber??""});
                        }
                    });
                    setOrganizations(Array.from(orgs));
                }
            }
        }
    }

    const handleOpenPopup = async () => {
        //await loadAllOrganizations();
        setShowPopup(true);
        setPopupSelectedOrganization(undefined);
    };

    const handleClosePopup = () => {
        setShowPopup(false);
        setPopupSelectedOrganization(undefined);
    };

    return <div>
        <TopLive titel={localizedTexts.title??""}/>
        <div className={"container-fluid mt-3"}>
            <div className={'card'}>
                <div className={'card-body'}>
                    <div className={'row'}>
                        <div className={'col-3'}>
                            <label>{localizedTexts.labelDiscipline}:&nbsp;</label>
                            <WinFireDropDown buttonText={selectedDiscipline?.name??localizedTexts.labelSelectDiscipline??''} elements={scoreListDisciplines.map(d => {
                                return {
                                    text: d.name,
                                    key:d.name,
                                    selectFunction: d => setSelectedDiscipline(d),
                                    sourceObject:d
                                } as WinFireDropDownElement<ScoreListDisciplineDefinition>
                            })} elementFilter={(filter, obj) => obj.name?.toLowerCase().includes(filter.toLowerCase())??true} />
                        </div>
                        <div className={'col-3'}>
                            <label>{localizedTexts.labelProgram}:&nbsp;</label>
                            <WinFireDropDown buttonText={selectedProgram?.name??(selectedDiscipline ? localizedTexts.labelSelectProgram:'') ?? ''} elements={selectedDiscipline?.scoreListDefinitions?.map(d => {
                                return {
                                    text: d.name,
                                    key:d.name,
                                    selectFunction: d => {setSelectedProgram(d); setGroupSelected(false)},
                                    sourceObject:d
                                } as WinFireDropDownElement<ScoreListDisciplineDefinition>
                            })??[]} elementFilter={(filter, obj) => obj.name?.toLowerCase().includes(filter.toLowerCase())??true} />
                        </div>
                        <div className={'col-1 mt-2'}>
                            {
                                selectedProgram && selectedProgram.hasGroup && <div className="form-check form-switch">
                                    <input className="form-check-input" type="checkbox" checked={groupSelected}
                                           onChange={(evt) => {
                                               setGroupSelected(!groupSelected && (selectedProgram?.hasGroup??false));
                                               setSectionSelected(false);
                                           }}
                                           id="flexSwitchCheckDefault"/>
                                    <label className="form-check-label" htmlFor="flexSwitchCheckDefault">{localizedTexts.labelGroup}</label>
                                </div>
                            }
                            {
                                selectedProgram && selectedProgram.isSection && <div className="form-check form-switch">
                                    <input className="form-check-input" type="checkbox" checked={sectionSelected}
                                           onChange={(evt) => {
                                               setSectionSelected(!sectionSelected && (selectedProgram?.isSection??false));
                                               setGroupSelected(false);
                                           }}
                                           id="flexSwitchCheckDefaultSection"/>
                                    <label className="form-check-label" htmlFor="flexSwitchCheckDefaultSection">{localizedTexts.labelSection}</label>
                                </div>
                            }
                        </div>
                        {
                            <div className={'col-3'}>
                                <label>{localizedTexts.labelField}:&nbsp;</label>
                                <WinFireDropDown buttonText={selectedField?.name??(selectedDiscipline ? localizedTexts.labelAllFields:'') ?? ''} elements={[{
                                    text: localizedTexts.labelAllFields,
                                    key: 'allfields',
                                    selectFunction: (d:ScoreListDisciplineDefinition|undefined) => setSelectedField(d),
                                    sourceObject:undefined as ScoreListDisciplineDefinition|undefined
                                }].concat(selectedDiscipline?.scoreListFieldDefinitions?.map(d => {
                                    return {
                                        text: d.name,
                                        key:d.name,
                                        selectFunction: d => setSelectedField(d),
                                        sourceObject:d
                                    } as WinFireDropDownElement<ScoreListDisciplineDefinition|undefined>
                                })??[])} elementFilter={(filter, obj) => obj?.name?.toLowerCase().includes(filter.toLowerCase())??true} />
                            </div>
                        }
                    </div>
                    <div className={'row mt-3'}>
                        <div className={'col-3'}>
                            <label>{localizedTexts.labelSearch}:&nbsp;</label>
                            <input className={'form-control'} type="text" value={filter} onChange={(e) => setFilter(e.target.value)}/>
                        </div>
                        <div className={'col-6'}>
                            <label>{localizedTexts.labelOrganizations}:&nbsp;</label><br />
                            <WinFireDropDown buttonText={selectedOrganization?.organizationName?? localizedTexts.labelAllOrgs ?? ''} elements={[{
                                text: localizedTexts.labelAllOrgs??'',
                                key: 'allOrgs',
                                selectFunction: (o:{organizationName:string, organizationNumber:string}|undefined) => setSelectedOrganization(o),
                                sourceObject:undefined as {organizationName:string, organizationNumber:string}|undefined
                            }].concat(organizations.map(o => {
                                return {
                                    text: o.organizationName,
                                    key:o.organizationNumber,
                                    selectFunction: o => setSelectedOrganization(o),
                                    sourceObject:o
                                } as WinFireDropDownElement<{organizationName:string, organizationNumber:string}|undefined>
                            }))} elementFilter={(filter, obj) => obj?.organizationName.toLowerCase().includes(filter.toLowerCase())??true} />
                        </div>
                        <div className={'col-3'}>
                            { selectedOrganization &&
                                <a className={"btn btn-primary mt-4"} target={"_blank"} rel={"noreferrer"}
                                   href={`${process.env.REACT_APP_API_LOCATION}/api/public/events/${eventId}/LiveOrganizations/${selectedDiscipline?.disciplineId ?? 1}/results/${selectedOrganization?.organizationNumber}`}><i
                                    className="bi bi-download"></i> {localizedTexts.titleDownloadOrganizationResultsPDF}</a>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className={'container-fluid mt-3'}>
            {
                groupSelected && <div className={'card'}>
                    <div className={'card-header'}>
                        <h2>{groupScoreList?.name}</h2>
                    </div>
                    <div className={'card-body'}>
                        <table className={'table table-striped table-hover'}>
                            <thead>
                            <tr>
                                <th>{localizedTexts.headerRank}</th>
                                <th className={'text-start'}>{localizedTexts.headerName}</th>
                                <th></th>
                                <th></th>
                                <th className={'text-start'}></th>
                                <th className={'text-end'}>{localizedTexts.headerResult}</th>
                                <th className={'text-start'}>{localizedTexts.headerOrganisation}</th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                groupScoreList?.scoreListItems?.filter(sli => selectedOrganization == undefined ? true : selectedOrganization.organizationName == sli.organization).filter(sli => (sli.name?.toLowerCase().indexOf(filter.toLowerCase())??1) > -1
                                    || (sli.organization?.toLowerCase().indexOf(filter.toLowerCase())??1) > -1).flatMap(s => {
                                    const res = Array<JSX.Element>();
                                    res.push(<tr  key={`${s.rank}${s.name}${s.organizationNumber}`}>
                                        <th>{s.rank}</th>
                                        <th className={'text-start'}>{s.name}</th>
                                        <th></th>
                                        <th></th>
                                        <th className={'text-start'}></th>
                                        <th className={'text-end'}>{scoreList?.isTenthScore ? s.score?.toFixed(2) : s.score?.toFixed(0)}</th>
                                        <th className={'text-start'}>{s.organization}</th>
                                    </tr>);

                                    s.scoreListItems?.forEach(sli => {
                                        res.push(<tr key={`${s.rank}${s.name}${s.organizationNumber}${sli.licenseNumber}`}>
                                            <td></td>
                                            <td className={'text-start'}>{sli.name}</td>
                                            <td>{sli.ageCategory}</td>
                                            <td>{sli.birthyear}</td>
                                            <td className={'text-start'}>{sli.weaponName}</td>
                                            <td className={'text-end'}>{scoreList?.isTenthScore ? sli.score?.toFixed(2) : sli.score?.toFixed(0)}</td>
                                            <td className={'text-start'}></td>
                                        </tr>)
                                    })

                                    res.push(<tr><td rowSpan={2} colSpan={7} style={{height:'5px'}}><div style={{width: '100%', height: '2px', backgroundColor: 'black'}}></div></td></tr>);
                                    res.push(<tr></tr>);
                                    return res??[];
                                })
                            }
                            </tbody>
                        </table>
                    </div>
                </div>
            }
            {
                !groupSelected && !sectionSelected  && <div className={'card'}>
                    <div className={'card-header'}>
                        <h2>{scoreList?.name}</h2>
                    </div>
                    <div className={'card-body'}>
                        <table className={'table table-striped table-hover'}>
                            <thead>
                            <tr>
                                <th>{localizedTexts.headerRank}</th>
                                <th className={'text-start'}>{localizedTexts.headerName}</th>
                                <th>{localizedTexts.headerAgeCat}</th>
                                <th>{localizedTexts.headerBirthyear}</th>
                                <th className={'text-start'}>{localizedTexts.headerWeapon}</th>
                                <th className={'text-end'}>{localizedTexts.headerResult}</th>
                                <th className={'text-start'}>{localizedTexts.headerOrganisation}</th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                scoreList?.scoreListItems?.filter(sli => selectedOrganization == undefined ? true : selectedOrganization.organizationName == sli.organization).filter(sli => (sli.name?.toLowerCase().indexOf(filter.toLowerCase())??1) > -1
                                    || (sli.organization?.toLowerCase().indexOf(filter.toLowerCase())??1) > -1
                                    || (sli.licenseNumber?.toLowerCase().indexOf(filter.toLowerCase())??1) > -1).map(s => {
                                    return <tr key={`${s.rank}${s.name}${s.birthyear}`}>
                                        <td>{s.rank}</td>
                                        <td className={'text-start'}>{s.name}</td>
                                        <td>{s.ageCategory}</td>
                                        <td>{s.birthyear}</td>
                                        <td className={'text-start'}>{s.weaponName}</td>
                                        <td className={'text-end'}>{scoreList?.isTenthScore ? s.score?.toFixed(2) : s.score?.toFixed(0)}</td>
                                        <td className={'text-start'}>{s.organization}</td>
                                    </tr>
                                })
                            }
                            </tbody>
                        </table>
                    </div>
                </div>
            }
            {
                sectionSelected && <div className={'card'}>
                    <div className={'card-header'}>
                        <h2>{scoreList?.name}</h2>
                    </div>
                    <div className={'card-body'}>
                        <table className={'table table-striped table-hover'}>
                            <thead>
                            <tr>
                                <th>{localizedTexts.headerRank}</th>
                                <th className={'text-end'}>{localizedTexts.headerResult}</th>
                                <th className={'text-end'}>{localizedTexts.headerParticipantCount}</th>
                                <th className={'text-end'}>{localizedTexts.headerMinimumMandatoryParticipantCount}</th>
                                <th className={'text-end'}>{localizedTexts.headerMandatoryParticipantCount}</th>
                                <th className={'text-end'}>{localizedTexts.headerOrganisationCategory}</th>
                                <th className={'text-start'}>{localizedTexts.headerOrganisation}</th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                sectionScoreList?.sectionScoreListItems?.filter(sli => (sli.organizationName?.toLowerCase().indexOf(filter.toLowerCase())??1) > -1
                                    || (sli.organizationCity?.toLowerCase().indexOf(filter.toLowerCase())??1) > -1).map(s => {
                                    return <tr key={`section-${s.organizationNumber}`}>
                                        <td>{s.rank}</td>
                                        <td className={'text-end'}>{s.resultat?.toFixed(3)}</td>
                                        <td className={'text-end'}>{s.participantCount}</td>
                                        <td className={'text-end'}>{s.minimalMandatoryParticipantCount}</td>
                                        <td className={'text-end'}>{s.mandatoryParticipantCount}</td>
                                        <td className={'text-end'}>{s.organizationCategory}</td>
                                        <td className={'text-start'}>{s.organizationName}</td>
                                    </tr>
                                })
                            }
                            </tbody>
                        </table>
                    </div>
                </div>
            }

        </div>

    </div>
}

export default ScoreListView;